import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const services = [
  {
    icon: 'ri-road-line',
    title: '道路工事',
    desc: '舗装補修・拡幅・改良工事などの道路工事現場における交通誘導。車両・歩行者の安全を確保し、円滑な工事進行をサポートします。',
    scenes: ['舗装補修', '車線規制', '歩行者誘導'],
  },
  {
    icon: 'ri-drop-line',
    title: '上下水道工事',
    desc: '水道管・下水道管の埋設・修繕工事に伴う道路掘削現場での誘導警備。片側通行規制や迂回誘導など、地域の生活に配慮した対応を行います。',
    scenes: ['掘削現場対応', '片側交互通行', '迂回誘導'],
  },
  {
    icon: 'ri-building-2-line',
    title: '新築建築工事',
    desc: '住宅・マンション・商業施設などの新築工事現場周辺の交通誘導。資材搬入・大型車両の出入りに合わせた柔軟な対応が強みです。',
    scenes: ['資材搬入補助', '大型車両誘導', '周辺交通整理'],
  },
  {
    icon: 'ri-hammer-line',
    title: '解体工事',
    desc: '建物・構造物の解体工事に伴う廃材搬出や重機作業時の周辺誘導。粉じん・騒音が発生しやすい環境でも安全第一で対応します。',
    scenes: ['重機作業時誘導', '廃材搬出補助', '歩行者安全確保'],
  },
  {
    icon: 'ri-parking-box-line',
    title: '駐車場・商業施設',
    desc: '商業施設・イベント会場・病院などの駐車場内誘導や周辺交通整理。混雑時でも来場者がスムーズに動けるよう誘導します。',
    scenes: ['入出庫誘導', '混雑時整理', 'イベント対応'],
  },
  {
    icon: 'ri-tools-line',
    title: 'その他の現場',
    desc: 'ガス管工事・電気設備工事・通信ケーブル工事など、地中埋設工事全般にも対応。現場の種類を問わず、まずはお気軽にご相談ください。',
    scenes: ['ガス管工事', '電気・通信工事', '臨機応変に対応'],
  },
];

export default function Services() {
  const { ref, isVisible } = useScrollAnimation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 bg-[#f4f7fb]">
      <div className="max-w-6xl mx-auto px-6">
        <div ref={ref} className={`fade-in-up ${isVisible ? 'visible' : ''}`}>

          <div className="text-center mb-16">
            <span className="text-[#38BDF8] text-sm font-medium tracking-widest">SERVICES</span>
            <h2 className="text-[#0D1A4E] text-3xl md:text-4xl font-black mt-3 mb-4">
              対応業務一覧
            </h2>
            <div className="w-12 h-1 bg-[#38BDF8] mx-auto"></div>
            <p className="text-gray-500 mt-6 max-w-xl mx-auto text-sm leading-relaxed">
              道路工事から建築・解体まで、一般道周辺のさまざまな現場に対応しています。<br />
              「こんな現場も頼める？」はまずお電話でご確認ください。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((item, idx) => (
              <div
                key={idx}
                className={`fade-in-up ${isVisible ? 'visible' : ''} group bg-white border border-gray-100 rounded-lg p-7 hover:border-[#38BDF8]/50 hover:bg-white transition-all duration-300`}
                style={{ transitionDelay: `${idx * 0.08}s` }}
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0D1A4E] rounded-lg flex-shrink-0 group-hover:bg-[#38BDF8] transition-colors duration-300">
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-[#0D1A4E] text-lg font-black mt-2">{item.title}</h3>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{item.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {item.scenes.map((scene) => (
                    <span
                      key={scene}
                      className="bg-[#38BDF8]/10 text-[#0D1A4E] text-xs px-2.5 py-1 rounded-full font-medium"
                    >
                      {scene}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-[#0D1A4E] rounded-lg p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <p className="text-white font-black text-lg mb-1">
                「この現場、対応できる？」——まず相談を
              </p>
              <p className="text-white/65 text-sm leading-relaxed">
                掲載以外の工事種別も柔軟に対応します。内容・規模・エリアを問わずお気軽にどうぞ。
              </p>
            </div>
            <button
              onClick={() => scrollTo('contact')}
              className="bg-[#38BDF8] hover:bg-[#7dd3fc] text-[#0D1A4E] px-8 py-3.5 rounded-md font-black whitespace-nowrap transition-colors cursor-pointer text-sm flex-shrink-0"
            >
              <i className="ri-file-list-3-line mr-2"></i>見積りを依頼する
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
